exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/_object-pie.js
// module id = 43
// module chunks = 0